import { Box, Typography } from "@mui/material";
import { StyledTypography } from "../../../styled-mui";

interface ColorSwatchesProps {
  swatches: any[]
}

export const ColorSwatches: React.FC<ColorSwatchesProps> = ({ swatches }) => {

  return (
    <Box>
      {/* 🔹 SWATCH ROW */}
      <StyledTypography variant="body4" component="p" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {swatches.length > 0 && <>{swatches.slice(0, 3)}</>} {swatches.length > 3 && <> +{swatches.length - 3}</>}
      </StyledTypography>

      {/* 🔹 CTA */}
      <Typography
        variant="body2"
        sx={{
          fontSize: "12px",
          mt: "4px",
          cursor: "pointer",
          textDecoration: "none",
        }}>
        Voir toutes les options
      </Typography>
    </Box>
  );
};

export default ColorSwatches;
